import { useCallback } from 'react';
import { Grid, GridItem, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { DataPrivacy } from '../datadog-privacy';
import { ColumnDefinitionEnumType } from '@mark43/cad-api';
import { QueueColumnHeader } from '../../../queues/components/queue-column-header';
import { WorkspaceQueue } from '../../../panels/workspace-queue';
import { useColumnDisplayNames } from '../../../queues/hooks/use-column-display-names';
import { DEFAULT_AS_COL_WIDTH } from './constants';

export const FrQueueColumnHeaders = observer(function FrQueueColumnHeaders({
    workspaceQueue,
    isSelfCol,
    unmaskedColumns,
}: {
    workspaceQueue: WorkspaceQueue;
    isSelfCol?: boolean;
    unmaskedColumns?: Set<string>;
}) {
    const columnDisplayNames = useColumnDisplayNames();
    const handleResize = useCallback(
        (width: string, columnDefinitionName: ColumnDefinitionEnumType) => {
            workspaceQueue.setColumnWidth(columnDefinitionName, parseInt(width, 10));
        },
        [workspaceQueue]
    );
    const handleReorder = useCallback(
        (columnDefinitionName: ColumnDefinitionEnumType, newIndex: number) => {
            workspaceQueue.setColumnOrder(columnDefinitionName, newIndex);
        },
        [workspaceQueue]
    );
    const gridTemplateColumns = isSelfCol
        ? `var(--columns) ${DEFAULT_AS_COL_WIDTH}px`
        : 'var(--columns)';

    return (
        <Grid data-testid="fr-compact-view-header" gridTemplateColumns={gridTemplateColumns}>
            {workspaceQueue.queueColumns.map((column, index) => {
                const columnDisplayName = columnDisplayNames[column.columnDefinition];
                return (
                    <QueueColumnHeader
                        key={column.columnDefinition}
                        index={index}
                        columnDefinition={column.columnDefinition}
                        onResize={handleResize}
                        onReorder={handleReorder}
                        header={
                            <DataPrivacy privacy={unmaskedColumns?.has(column.columnDefinition) ? 'unmask' : 'passthrough'}>
                                <Text style={{ pointerEvents: 'auto' }}>
                                    {columnDisplayName.displayAbbreviation}
                                </Text>
                            </DataPrivacy>
                        }
                        styles={{
                            fontSize: '18px',
                            backgroundColor: 'var(--arc-colors-surface-foreground)',
                        }}
                    />
                );
            })}
            {isSelfCol && <GridItem />}
        </Grid>
    );
});
